import { RequestMethodsEnum as a } from "@systemeio/util";
import { useFetch as s } from "../../../utils/http-client.mjs";
const u = () => {
  const { fetcher: r } = s({
    method: a.delete
  }), { fetcher: n } = s({
    method: a.get
  }), { fetcher: c } = s({
    method: a.post
  });
  return { deleteFile: async ({ id: e }) => {
    await r("/api/dashboard/customer/data-files/" + e);
  }, downloadFile: async ({ id: e }) => {
    const { link: o } = await n(`/api/dashboard/customer/data-files/${e}/download-link`), t = document.createElement("a");
    t.setAttribute("href", o), t.setAttribute("download", ""), t.click();
  }, renameFile: async ({ id: e, name: o }) => await c(`/api/dashboard/customer/data-files/${e}/rename`, {
    name: o
  }) };
};
export {
  u as useFileActions
};
